export default __webpack_public_path__ + "static/media/step_application.6d7d41bb.png";